<template>
  <b-modal :id="id" :title="title" centered scrollable size="lg">
    <slot name="info"></slot>
    <template #modal-footer="{ close }">
      <b-button class="w-100" variant="default" @click="close()">{{ $t('modal.button.close.label') }}</b-button>
    </template>
  </b-modal>
</template>
<script>
import Vue from 'vue'

import { ModalPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(ModalPlugin)

export default {
  i18n,
  name: 'info-modal',
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    }
  },
  components: {
    // 
  }
};
</script>
